import { PendingChangesActionType } from 'constants/pendingChanges';
import { COLOR_PALETTE } from 'constants/ui';

export const prepaidTableStyles = {
  borderRadius: '5px',

  '& tr ': {
    height: 48,
    position: 'relative',

    '&.table-row-pending td': {
      background: COLOR_PALETTE.ADDITIONAL[1],
    },
  },

  [`tbody tr.table-row-pending-${PendingChangesActionType.DELETED}::after`]: {
    position: 'absolute',
    content: "''",
    width: 'calc(100% - 40px)',
    top: '50%',
    bottom: 0,
    left: '20px',
    right: '20px',
    height: '1px',
    background: COLOR_PALETTE.ADDITIONAL[2],
  },

  '& th, td': {
    border: '1px solid',
    borderColor: ({ palette }) => palette.border.default,

    '&:nth-of-type(1)': {
      width: '22%',
      minWidth: '160px',
    },

    '&:nth-of-type(2)': {
      width: '22%',
      minWidth: '160px',
    },

    '&:nth-of-type(3)': {
      width: '22%',
      minWidth: '120px',
    },

    '&:nth-of-type(4)': {
      width: '6%',
      minWidth: '130px',
    },

    '&:nth-of-type(5)': {
      width: '22%',
      minWidth: '120px',
    },

    '&:nth-of-type(6)': {
      minWidth: '71px',
    },
  },

  '& tbody th, tbody td': {
    color: ({ palette }) => palette.text.secondary,
    position: 'relative',
  },
};
